import { useLayoutEffect, useState } from 'react';

export const useMouseCoords = () => {
  const [mouseX, setMouseX] = useState<number>(0);
  const [mouseY, setMouseY] = useState<number>(0);

  const updateMouseCoords = (e: any) => {
    setMouseX(e.offsetX);
    setMouseY(e.offsetY);
  };

  useLayoutEffect(() => {
    window.addEventListener('mousemove', updateMouseCoords);
    return () => window.removeEventListener('mouseMove', updateMouseCoords);
  }, []);

  return { mouseX, mouseY };
};
